import { Field, FieldDescription, FieldError, FieldLabel } from '../ui/field'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select'
import type { GetGameBlindsRow } from '@/tygo/db'
import { useFieldContext } from '@/lib/form'
import { USDCToString } from '@/lib/currency'

export const ChooseBlinds = ({
  gameBlinds,
  userBalance,
}: {
  gameBlinds: Array<GetGameBlindsRow> | undefined
  userBalance: number | undefined
}) => {
  const field = useFieldContext<string>()

  const isBlindDisabled = (blind: GetGameBlindsRow) => {
    return userBalance !== undefined && userBalance < blind.default_min_buy_in
  }

  if (!gameBlinds) {
    return null
  }

  return (
    <Field>
      <div>
        <FieldLabel htmlFor="blinds">Select blinds</FieldLabel>
        <FieldDescription>
          Choose the small and big blind amounts.
        </FieldDescription>
      </div>
      <div>
        <Select value={field.state.value} onValueChange={field.handleChange}>
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Select blinds" />
          </SelectTrigger>
          <SelectContent>
            {gameBlinds.map((blind) => (
              <SelectItem
                key={blind.id}
                value={blind.id}
                disabled={isBlindDisabled(blind)}
                tooltip={
                  isBlindDisabled(blind)
                    ? 'You do not have enough funds to cover the minimum buy-in.'
                    : undefined
                }
              >
                ${USDCToString(blind.small_blind)} / $
                {USDCToString(blind.big_blind)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <FieldError errors={field.state.meta.errors} />
    </Field>
  )
}
